var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-3 is-gallery"},[_c('div',{staticClass:"card"},[_c('v-lazy-image',{staticClass:"image",attrs:{"width":"250","height":"250","src":require(("@/assets/images/gallery/" + _vm.image)),"alt":_vm.imageAlt}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }